import React from 'react'
import './AlertText.css'

type Props = {
  text: string
}

function AlertText(props: Props) {
  const { text } = props

  return (
    <span className="alert-text">{text}</span>
  )
}

export default AlertText